import React from 'react';
/*
import {
  hf,
  ht,
  cr,
  a,
  l,
  f,
  BoxC,
  GridC,
  TextC,
} from 'lib';
*/
import * as BoxC from "./_ccbBoxC";
import * as TextC from "./_ccbTextC";
import * as GridC from "./_cccGridC";
import * as cmFTH from "./_cmFTH"; // 廃止予定
import * as cr from './_cr';
import { a } from "./_csAbt";
import * as ls from "./_csLcl"; // local state
import * as ht from './_ht';
import * as hf from './_hf';
import * as ihd from './ihd';
import * as icvi1z from './icvI1z___Mz';

let $i1zrs = [] as ht.ls;

export const N = (pz: {
  sPz: ht.dz,
  cz: {
    i18r_fst: ht.n,
  }
}) => {

  const _frcUdt = ls.frcUdt();

  React.useEffect(() => {
    if ( pz.cz.i18r_fst > 0 ) {
      cmFTH.loadAllAsync({
        phs: pz.sPz.crt.phs,
        frcUdt: _frcUdt,
        bfrAsync: () => [
          icvi1z.loadI1zrLsAsync({
            i1zr_fst: pz.sPz.crt.i1zr_fst,
            i18r_fst: pz.cz.i18r_fst,
            tailz: {
              odr: 'i1zrd3100s desc',
              lmt: 30
            },
            lwrType: 1,
          })
          .then((_ls: ht.ls) => {
            $i1zrs = _ls;
          })
        ],
      })
    }
    else {
      $i1zrs = [];
      _frcUdt();
    }
  }, [
    pz.cz.i18r_fst,
  ])

  const _hdrs = [] as ht.ls;
  const _bdys = [] as ht.ls;
  _hdrs.push(
    {
      boxStlz: a('bs/dt'),
      cellCs: [
        {
          boxStlz: a('f/1'),
          oClds: [
            cr.c(TextC.N, {
              key: -10,
              abtType: 'lblStfz',
              textz: {
                pfx: 'ID'
              },
            })
          ]
        },
        {
          boxStlz: a('f/1.5'),
          oClds: [
            cr.c(TextC.N, {
              key: -10,
              abtType: 'lblStfz',
              textz: {
                pfx: '利用日'
              },
            })
          ]
        },
        {
          boxStlz: a('f/1.5'),
          oClds: [
            cr.c(TextC.N, {
              key: -10,
              abtType: 'lblStfz',
              textz: {
                pfx: '部屋'
              },
            })
          ]
        },
        {
          boxStlz: a('f/2'),
          oClds: [
            cr.c(TextC.N, {
              key: -10,
              abtType: 'lblStfz',
              textz: {
                pfx: '時間帯'
              },
            })
          ]
        },
        {
          boxStlz: a('f/2'),
          oClds: [
            cr.c(TextC.N, {
              key: -10,
              abtType: 'lblStfz',
              textz: {
                pfx: '施設'
              },
            })
          ]
        },
        {
          boxStlz: a('dwe/6 f/n'),
          oClds: [
            cr.c(TextC.N, {
              key: -10,
              abtType: 'lblStfz',
              textz: {
                pfx: '経路'
              },
            })
          ]
        },
        {
          boxStlz: a('f/2'),
          oClds: [
            cr.c(TextC.N, {
              key: -10,
              abtType: 'lblStfz',
              textz: {
                pfx: 'エントリー状況'
              },
            })
          ]
        },
        {
          boxStlz: a('f/1'),
          oClds: [
            cr.c(TextC.N, {
              key: -10,
              abtType: 'lblStfz',
              textz: {
                pfx: '予約状況'
              },
            })
          ]
        },
      ]
    }
  );

  $i1zrs.map( (_i1zrz: ht.dz) => {
    _bdys.push(
      {
        cellCs: [
          {
            boxStlz: a('f/1 fd/rcc'),
            oClds: [
              cr.c(TextC.N, {
                key: -10,
                textz: {
                  pfx: _i1zrz._icn
                },
              })
            ]
          },
          {
            boxStlz: a('f/1.5 fd/rcc'),
            oClds: [
              cr.c(TextC.N, {
                key: -10,
                textz: {
                  pfx: _i1zrz.i1zrd3100s,
                  ptyz: a(`tn/1`),
                },
              })
            ]
          },
          {
            boxStlz: a('f/1.5 fd/rcc'),
            oClds: [
              cr.c(TextC.N, {
                key: -10,
                textz: {
                  pfx: _i1zrz.i1zra1100s,
                  ptyz: a(`tn/1`),
                },
              })
            ]
          },
          {
            boxStlz: a('f/2 fd/rcc'),
            oClds: [
              cr.c(TextC.N, {
                key: -10,
                textz: {
                  pfx: _i1zrz.i1zra1200s,
                  ptyz: a('tn/1'),
                },
              })
            ]
          },
          {
            boxStlz: a('f/2 fd/rcc'),
            oClds: [
              cr.c(TextC.N, {
                key: -10,
                textz: {
                  pfx: hf.get1(_i1zrz.cldz._31rs)?._pfx ?? '',
                  ptyz: a(`tn/1`),
                },
              })
            ]
          },
          {
            boxStlz: a('dw/6 f/n fd/rcc'),
            oClds: [
              cr.c(TextC.N, {
                key: -10,
                textz: {
                  pfx: ihd.r(ihd.f('i1zra6100i').ls, _i1zrz.i1zra6100i ?? -1)
                },
              })
            ]
          },

          {
            boxStlz: a('f/2 fd/rcc'),
            oClds: [
              cr.c(TextC.N, {
                key: -10,
                textz: {
                  pfx: ihd.r(ihd.f('i1zrs1200i').ls, _i1zrz.i1zrs1200i),
                  ptyz: a(`tn/1`),
                },
              })
            ]
          },
          {
            boxStlz: a('f/1 fd/rcc'),
            oClds: [
              cr.c(TextC.N, {
                key: -10,
                textz: {
                  pfx: ihd.r(ihd.f('i1zrs1100i').ls, _i1zrz.i1zrs1100i),
                  ptyz: a(`tn/1`),
                },
              })
            ]
          },
        ]
      }
    );
  });

  return (
    cr.c(BoxC.N, {
      key: 'Iccv23b3c.root',
      boxStlz: a('dw/f'),
      oClds: [

        cr.c(GridC.N, {
          key: -10,
          abtType: 'hdrStfz',
          boxStlz: a('dw/f bs/dt'),
          lineCs: _hdrs
        }),

        cr.c(GridC.N, {
          key: -20,
          abtType: 'lineStfz',
          boxStlz: a('dw/f bs/dt'),
          lineCs: _bdys,
          msgCz: {
            textz: {
              pfx: '該当なし',
              stlz: a('mb/1'),
            }
          }
        })

      ]
    })
  );
};
